/* eslint-disable generator-star-spacing */
/* eslint space-before-function-paren: "off" */
import type { SagaIterator } from 'redux-saga'
import { call, delay, put, takeLatest } from 'redux-saga/effects'
import { toast } from 'react-toastify'

import { Files, Punchlist } from '../../api'
import { errorTextTryingTo, getFileExtension } from '../../helpers'

import {
  DownloadFileAction,
  filesTypes,
  GetPDFAction,
  UploadFileAction,
  UploadFilesAction
} from './types'
import { filesActions } from '../actions'

export function* uploadFile({ payload, callback }: UploadFileAction): SagaIterator {
  let success = false

  try {
    const extension = getFileExtension(payload)
    console.log('extension', extension)
    const { fileName, uploadUrl } = yield call(Punchlist.files.uploadFile, { extension })

    const result = yield call(Files.uploadFile, uploadUrl, payload)
    success = result !== null
    yield call(callback, success, fileName)
  } catch (error) {
    yield call(toast.error, errorTextTryingTo('upload a file'))
    yield call(callback, false)
  }
}

export function* uploadFiles({ payload, callback }: UploadFilesAction): SagaIterator {
  let success = true
  const fileNameList: string[] = []
  try {
    for (let index = 0; index < payload.length; index++) {
      if (success) {
        const file = payload[index] as File
        const extension = getFileExtension(file)
        const { fileName, uploadUrl } = yield call(Punchlist.files.uploadFile, { extension })
        const result = yield call(Files.uploadFile, uploadUrl, file)
        if (result !== null) fileNameList.push(fileName)
        else success = false
      }
    }
    yield call(callback, success, fileNameList)
  } catch (error) {
    yield call(toast.error, errorTextTryingTo('upload a file'))
    yield call(callback, false)
  }
}

export function* downloadFile({ payload, callback }: DownloadFileAction): SagaIterator {
  try {
    const { documentType, resourceId, parameters } = payload
    const response = yield call(Files.downloadFile, documentType, resourceId, parameters)
    const reportId = response.data
    if (reportId) {
      yield put(filesActions.getPDF(reportId, callback))
    } else {
      yield call(toast.error, errorTextTryingTo('download pdf file'))
      yield call(callback, false)
    }
  } catch (error) {
    yield call(toast.error, errorTextTryingTo('download pdf file'))
    yield call(callback, false)
  }
}

export function* getPDF({ payload, callback }: GetPDFAction): SagaIterator {
  try {
    const response = yield call(Files.getPDF, payload)
    if (response.status === 200) {
      yield put(filesActions.setPDF(response.data))
      yield call(callback, true)
    } else {
      yield delay(1500)
      yield put(filesActions.getPDF(payload, callback))
    }
  } catch (error) {
    yield call(toast.error, errorTextTryingTo('download pdf file'))
    yield call(callback, false)
  }
}

export default function* saga(): SagaIterator {
  yield takeLatest(filesTypes.UPLOAD_FILE, uploadFile)
  yield takeLatest(filesTypes.UPLOAD_FILES, uploadFiles)
  yield takeLatest(filesTypes.DOWNLOAD_FILE, downloadFile)
  yield takeLatest(filesTypes.GET_PDF, getPDF)
}
